<div *ngIf="displayError">
  <div [ngClass]="{ 'new-error-msg': newDesign, 'error-msg': !newDesign }">
    {{ errorMsg }}
  </div>
</div>
